<template>
  <div class="tiktok">
    <el-table class="tiktok_list" :data="list" border>
      <el-table-column type="index" label="排名" width="100" align="center">
      </el-table-column>
      <!-- <el-table-column prop="avatar" label="头像" width="120" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 44px; height: 44px"
            :src="scope.row.avatar"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column> -->
      <el-table-column prop="nickName" label="抖音昵称" align="center">
      </el-table-column>
      <el-table-column prop="teamName" label="团队名称" align="center">
      </el-table-column>
      <!-- <el-table-column prop="account" label="抖音号" width="120" align="center">
      </el-table-column> -->
      <!-- <el-table-column prop="fansCount" label="粉丝量" width="100" align="center">
      </el-table-column> -->
      <el-table-column
        prop="playCount"
        label="播放量"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="diggCount"
        label="点赞量"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="commentCount"
        label="评论量"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="forwardCount"
        label="转发量"
        width="100"
        align="center"
      >
      </el-table-column>
      <!-- <el-table-column prop="score" label="分数" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { tiktokList } from "@/api/team";
import { formatDate } from "@/utils/index";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      tiktokList({ classId: this.$route.query.id }).then(
        ({ code, data, msg }) => {
          this.$loading.hide();
          if (code == 0) {
            if (data && data.length > 0) {
              data[0].nickName = "妙笔生花";
              data[0].playCount = 636000;
              data[0].diggCount = 100071;
              data[0].commentCount = 47706;
              data[0].forwardCount = 954;
            }

            this.list = data;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 翻页
    pageChange() {},
    // 导出
    onExport() {},
  },
};
</script>

<style lang="less" scoped>
.tiktok {
  background-color: rgb(255, 255, 255);

  .top_row {
    margin-bottom: 10px;
    line-height: 32px;
    overflow: hidden;

    .title {
      float: left;
    }

    .btn {
      float: right;
    }
  }

  ::v-deep .tiktok_list {
    .is-leaf {
      color: #fff;
      background-color: #0088ff;
    }

    .rank_num {
      display: inline-block;
      width: 22px;
      height: 22px;
      background: #f0f2f5;
      border-radius: 50%;
    }
  }
}
</style>
